module.exports = new __parcel__URL__("BrickVideoStudio.fa00b2ff.webp").toString();